import { SVGProps } from 'react';

const MapPinScaleLargeAppearanceOutlined = (props: SVGProps<SVGSVGElement>) => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M28 13.3333C28 22.6667 16 30.6667 16 30.6667C16 30.6667 4 22.6667 4 13.3333C4 10.1507 5.26428 7.09849 7.51472 4.84805C9.76516 2.59762 12.8174 1.33334 16 1.33334C19.1826 1.33334 22.2348 2.59762 24.4853 4.84805C26.7357 7.09849 28 10.1507 28 13.3333Z"
            stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            strokeWidth={2.66667}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M16 17.3333C18.2091 17.3333 20 15.5425 20 13.3333C20 11.1242 18.2091 9.33334 16 9.33334C13.7909 9.33334 12 11.1242 12 13.3333C12 15.5425 13.7909 17.3333 16 17.3333Z"
            stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            strokeWidth={2.66667}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export default MapPinScaleLargeAppearanceOutlined;
